import { render, staticRenderFns } from "./QuizOverview.vue?vue&type=template&id=19237e9d&scoped=true&"
import script from "./QuizOverview.vue?vue&type=script&lang=ts&"
export * from "./QuizOverview.vue?vue&type=script&lang=ts&"
import style0 from "./QuizOverview.vue?vue&type=style&index=0&id=19237e9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19237e9d",
  null
  
)

export default component.exports